import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Rating,
} from "@mui/material";
import React, { useState, useCallback } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddTestimonialModal from "../components/AddTestimonialModal";
import ReactQuill from "react-quill";

const ServiceCenterTestimonials = ({ title, data, setData }) => {
  // If data.testimonials is an array (legacy), migrate it to object. Otherwise use it as object.
  const testimonialData = Array.isArray(data?.testimonials) 
    ? { title: "", description: "", testimonials: data.testimonials } 
    : (data?.testimonials || { title: "", description: "", testimonials: [] });
  
  const testimonialsList = Array.isArray(testimonialData.testimonials) ? testimonialData.testimonials : [];

  const [showModal, setShowModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  const handleModal = useCallback((show = false, selectedObj = null) => {
    setShowModal(show);
    setSelectedTestimonial(selectedObj);
  }, []);

  const handleChange = useCallback((name) => (value) => {
    setData((prev) => {
      const prevTestimonials = Array.isArray(prev.testimonials) 
        ? { title: "", description: "", testimonials: prev.testimonials } 
        : (prev.testimonials || {});

      return {
        ...prev,
        testimonials: {
          ...prevTestimonials,
          [name]: value || ""
        }
      };
    });
  }, [setData]);

  const handleAdd = useCallback((form) => {
    let { index, ...rest } = form;

    setData((prev) => {
      const prevTestimonials = Array.isArray(prev.testimonials) 
        ? { title: "", description: "", testimonials: prev.testimonials } 
        : (prev.testimonials || { title: "", description: "", testimonials: [] });
      
      const currentList = Array.isArray(prevTestimonials.testimonials) ? prevTestimonials.testimonials : [];

      let updatedList;
      if (index !== undefined) {
        updatedList = currentList.map((item, i) => i === index ? rest : item);
      } else {
        updatedList = [...currentList, rest];
      }

      return {
        ...prev,
        testimonials: { ...prevTestimonials, testimonials: updatedList }
      };
    });
  }, [setData]);

  const handleDelete = useCallback((index) => {
    setData((prev) => {
      const prevTestimonials = Array.isArray(prev.testimonials) 
        ? { title: "", description: "", testimonials: prev.testimonials } 
        : (prev.testimonials || { title: "", description: "", testimonials: [] });
      
      const currentList = Array.isArray(prevTestimonials.testimonials) ? prevTestimonials.testimonials : [];

      return {
        ...prev,
        testimonials: {
          ...prevTestimonials,
          testimonials: currentList.filter((_, i) => i !== index)
        }
      };
    });
  }, [setData]);

  return (
    <Box mt={4}>
      <Typography fontWeight="600" mb={2}>
        {title}
      </Typography>

      <div className="form_comp">
        <label>Testimonial Title</label>
        <ReactQuill
          value={testimonialData.title || ""}
          onChange={handleChange("title")}
        />
      </div>

      <div className="form_comp mt15">
        <label>Testimonial Description</label>
        <ReactQuill
          value={testimonialData.description || ""}
          onChange={handleChange("description")}
        />
      </div>

      <Button
        variant="contained"
        sx={{ mb: 3, mt: 2 }}
        onClick={() => handleModal(true)}
      >
        + Add Testimonial
      </Button>

      {/* TABLE */}
      {testimonialsList.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Name</b></TableCell>
                <TableCell><b>Description</b></TableCell>
                <TableCell><b>Rating</b></TableCell>
                <TableCell><b>Edit</b></TableCell>
                <TableCell><b>Delete</b></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {testimonialsList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.name}</TableCell>

                  <TableCell>
                    <Typography
                      dangerouslySetInnerHTML={{ __html: item.description || item.review || "" }}
                    />
                  </TableCell>

                  <TableCell>
                    <Rating value={item.rating} readOnly />
                  </TableCell>

                  <TableCell onClick={() => handleModal(true, { ...item, index })}>
                    <EditIcon sx={{ cursor: "pointer" }} />
                  </TableCell>

                  <TableCell onClick={() => handleDelete(index)}>
                    <DeleteIcon sx={{ cursor: "pointer", color: "gray" }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <AddTestimonialModal
        open={showModal}
        handleClose={() => handleModal(false)}
        selectedTestimonial={selectedTestimonial}
        handleTestimonial={handleAdd}
      />
    </Box>
  );
};

export default ServiceCenterTestimonials;
